const _state = {
  affectedRoleData: null,
}
//{roleId:Guid, operation:I/U} Insert o Update

export const initialState = () => _state

export const state = initialState()
